module.exports = __webpack_public_path__ + "img/not-found.6ed05182.svg";